import { Component } from '@angular/core';

@Component({
    selector: 'teller-online-icon-plus',
    templateUrl: '../svgs/Plus.svg',
    host: {
        class: 'teller-online-icon teller-online-icon--plus'
    },
    standalone: false
})
export class TellerOnlineIconPlus {
}
